import construcao from "./construcao.svg";
import BotaoVoltar from '../../components/botoes/BotaoVoltar';
import './emConstrucao.css';

export default function EmConstrucao() {
    return (
        <div className="container-system-page">
            <div>
                <h5 className="mb-3">Página em construção</h5>
                <img
                    src={construcao}
                    className="mx-auto"
                    style={{
                        maxHeight: "100%",
                        width: "10rem",
                        objectFit: "cover",
                    }}
                    alt="Imagem não encontrada"
                />
            </div>
            <BotaoVoltar className="botao-voltar" />
        </div>
    );
}
